import * as device from 'react-device-detect'

export function openExternalLink(url: string): void {
  const redirectTarget = device.isSafari ? '_self' : '_blank'

  window.open(url, redirectTarget, 'noopener noreferrer')
}
